import { Type } from "@shared/ui/Type";
import { ClipboardCopyButton } from "@shared/ui/ClipboardCopyButton";
import { DownloadableAssetImage } from "@shared/ui/DownloadableAssetImage";
import { DownloadableAssetFile } from "@shared/ui/DownloadableAssetFile";
import { WelcomeKitData } from "@platform/types/dashboard.types";
import { ProgramResourcesSection } from "../ProgramResourcesSection/ProgramResourcesSection";

export type Props = {
  title?: string;
  description?: string;
  data?: WelcomeKitData;
  className?: string;
};

export function ProgramWelcomeKit({
  title,
  description,
  data,
  className,
}: Props) {
  // Ensure data object is correctly structured
  const safeData = {
    files: Array.isArray(data?.files) ? data.files : [],
    images: Array.isArray(data?.images) ? data.images : [],
    captions: Array.isArray(data?.captions) ? data.captions : [],
    links: Array.isArray(data?.links) ? data.links : [],
  };

  // Check if we have files, images, or captions to display
  const hasFiles = safeData.files.length > 0;
  const hasImages = safeData.images.length > 0;
  const hasCaptions = safeData.captions.length > 0;

  return (
    <ProgramResourcesSection
      className={className}
      title={title}
      description={description}
    >
      {hasFiles && safeData.files.length > 0 && (
        <DownloadableAssetFile file={safeData.files[0]} />
      )}
      {hasCaptions && safeData.captions.length > 0 && (
        <div className="p-6 rounded-md border border-brand-800 flex flex-col gap-4 md:gap-8 md:p-12">
          <Type variant="caption" className="text-brand-700">
            {safeData.captions[0].text}
          </Type>
          <div className="mt-auto">
            <ClipboardCopyButton
              textToCopy={safeData.captions[0].text}
              label="Copy caption"
            />
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
        {hasImages &&
          safeData.images.map((image, index) => (
            <DownloadableAssetImage
              key={`image-${index}`}
              alt={image.alt}
              src={image.imageUrl}
              downloadUrl={image.downloadUrl}
              label="Download image"
            />
          ))}
      </div>
    </ProgramResourcesSection>
  );
}

export default ProgramWelcomeKit;
